// extracted by mini-css-extract-plugin
export default {"loader":"AuthFlowLoader_loader__77h9t","rotation":"AuthFlowLoader_rotation__WOWw7","loader-container":"AuthFlowLoader_loader-container__hlSYp"};